var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.147,
    height: 67.796,
    viewBox: "0 0 77.147 67.796",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1801",
    "data-name": "Group 1801",
    transform: "translate(0.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4523",
    "data-name": "Path 4523",
    d: "M-490.777,163.93v-4.941a3.985,3.985,0,0,1,1.137-3.171,3.985,3.985,0,0,1,3.16-1.167h38.8v2.993h-38.381c-1.511,0-1.735.22-1.734,1.747v3.543c0,1,0,1,.972,1h43.884a7.406,7.406,0,0,1,1.794.15,3.759,3.759,0,0,1,2.8,3.825q.006,10.858,0,21.716v11.284c.262.023.475.058.691.058q2.225.008,4.449,0c.961,0,1.1-.138,1.1-1.088V173.235h2.965c.015.288.042.556.042.822q0,12.932.009,25.863a3.568,3.568,0,0,1-1.586,3.368,5,5,0,0,1-2.182.651c-1.527.1-3.065.03-4.6.034-.27,0-.539.027-.887.047v4.87c0,2.863-1.508,4.378-4.357,4.378H-492.61c-2.8,0-4.353-1.537-4.353-4.32V168.156a3.857,3.857,0,0,1,1.1-3.107,3.856,3.856,0,0,1,3.1-1.124C-492.14,163.921-491.512,163.93-490.777,163.93Zm3.018,40.127h40.24c-.355-.811-.665-1.537-.988-2.262a74.28,74.28,0,0,0-6.268-11.9,19.159,19.159,0,0,0-2.9-3.344c-1.747-1.576-3.454-1.467-5.14.168a15.5,15.5,0,0,0-1.715,2c-1.272,1.745-2.426,3.579-3.755,5.277-1.886,2.409-3.2,2.424-5.362.279a21.587,21.587,0,0,0-2.273-2.086,3.889,3.889,0,0,0-4.958-.053,11.466,11.466,0,0,0-2.3,2.253,28.357,28.357,0,0,0-4.045,8.029c-.182.512-.34,1.03-.54,1.643Zm9.29-30.929a6.149,6.149,0,0,0-4.4,1.82,6.15,6.15,0,0,0-1.782,4.414,6.22,6.22,0,0,0,6.178,6.192,6.259,6.259,0,0,0,6.239-6.228,6.189,6.189,0,0,0-1.827-4.4,6.19,6.19,0,0,0-4.41-1.8Z",
    transform: "translate(496.963 -145.473)",
    fill: "#f18181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4524",
    "data-name": "Path 4524",
    d: "M-115.485,115.262h-3v-9.243h-9.176v-3h9.126V93.821h3.012v9.151h9.289v2.977c-.289.013-.557.035-.825.035-2.538,0-5.075.026-7.612-.013-.684-.011-.847.213-.838.86.033,2.511.012,5.024.012,7.536Z",
    transform: "translate(183.357 -93.821)",
    fill: "#f18181"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhoto);
export default __webpack_public_path__ + "static/media/add_photo.1f5b2a715bfa8628af0bab2a6502f083.svg";
export { ForwardRef as ReactComponent };